<template>
  <div class="join-modular">
    <div class="join-banner">
      <div class="join-title EC5 center">加入我们</div>
    </div>
    <div class="aboutUsContent pt120">
      <div class="lz-title1 mb64">热招岗位</div>
      <div>
        <el-radio-group class="join-job" v-model="joinActive">
          <el-radio-button
            v-for="(item, index) in tabArr"
            :key="`jt_${index}`"
            :label="item.title"
            class="join-name"
          ></el-radio-button>
        </el-radio-group>
      </div>
      <div
        v-for="(item, index) in tabArr"
        :key="`jc_${index}`"
        :class="item.title === joinActive ? '' : 'hide'"
      >
        <el-collapse
          class="jobItem"
          v-for="(sItem, sIndex) in item.position"
          :key="`jcc_${sIndex}`"
          v-model="tabArr[index].active"
          accordion
        >
          <el-collapse-item :name="sItem.title">
            <template slot="title">
              <div class="jobItemTitle">
                <span class="jobTitle">{{ sItem.title }}</span>
                <div class="iconDiv icon-icon_address"></div>
                <span class="jobAddress">{{ sItem.local }}</span>
              </div>
            </template>
            <div class="jobContent">
              <h3>岗位职责:</h3>
              <p class="jobDesc" v-html="sItem.duty"></p>
              <h3>岗位要求:</h3>
              <p class="jobDesc" v-html="sItem.demand"></p>
              <a href="javascript:void(0);">简历投至邮箱：hr@getchain.cn</a>
              <a class="apply-for" href="mailto:hr@getchain.cn">立即申请</a>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="welfare-concern pt120 pb96">
      <div class="lz-title1 mb64">福利关怀</div>
      <div class="w1200">
        <ul class="welfare-list">
          <li class="welfare-item">
            <img :src="require('@/assets/images/join2.png')" alt="" />
            <h4 class="welfare-title">成长型团队</h4>
            <p class="welfare-desc">
              科学合理的内部成长机制，加上多种项目机会，为你提供迅速成长的土壤！
            </p>
          </li>
          <li class="welfare-item">
            <img :src="require('@/assets/images/join2.png')" alt="" />
            <h4 class="welfare-title">丰厚年终奖</h4>
            <p class="welfare-desc">凭实力拿年终奖，能力越大年终奖越多！</p>
          </li>
          <li class="welfare-item">
            <img :src="require('@/assets/images/join2.png')" alt="" />
            <h4 class="welfare-title">员工活动</h4>
            <p class="welfare-desc">
              丰富员工活动,总有一项适合你:篮球赛、王者荣耀比赛、抽奖活动、羽毛球、极限挑战运动…
            </p>
          </li>
          <li class="welfare-item">
            <img :src="require('@/assets/images/join2.png')" alt="" />
            <h4 class="welfare-title">丰富下午茶</h4>
            <p class="welfare-desc">
              行政小姐姐变着花样准备下午茶，找回小时候的味道，补充能量……
            </p>
          </li>
          <li class="welfare-item">
            <img :src="require('@/assets/images/join2.png')" alt="" />
            <h4 class="welfare-title">奖励机制</h4>
            <p class="welfare-desc">
              优秀员工，优秀团队，团队明星……多样化的内部奖励让你成就感爆棚！
            </p>
          </li>
          <li class="welfare-item">
            <img :src="require('@/assets/images/join2.png')" alt="" />
            <h4 class="welfare-title">节日福利</h4>
            <p class="welfare-desc">
              生日活动，妇女节，端午节，中秋节，春节，情人节，程序员节……
              惊喜不断！
            </p>
          </li>
        </ul>
      </div>
    </div>
    
  </div>
</template>

<script>
import Free from '@/components/Free';
const tabArr = [{
  title: '产品',
  active: '高级产品经理',
  position: [
    {
      title: '高级产品经理',
      local: '',
      duty: '1、负责知链模块产品的规划：通过市场调研、客户反馈、客户使用路径梳理等方式提供用户友好性强、可拓展性强、有市场竞争力的产品能力迭代方向；并对所负责的产品模块的进展效果和整体业务发展负责。<br/>2、协调部门内/跨部门各方面资源，包括交互、设计、开发、运营等支持保证项目顺利成功推进。<br/>3、具备批判性思维和产品敏感度，帮助和带领团队特别是初级产品经理的成长，为其方案的质量和效果保驾护航，为其项目的推进献计献策。',
      demand: '1、全日制本科以上学历，计算机等相关专业。<br/>2、具有三年以上的Web应用开发经验，熟悉HTML、JavaScript、CSS、XML、vue等web开发领域及相关技术。<br/>3、具有微信H5开发或者小程序开发者优先，有相关作品的优先。<br/>4、有较强的责任感，学习能力强，有创造性思维能力和表达能力，充满创业激情。'
    }
  ]
}, {
  title: '技术',
  active: '前端开发工程师',
  position: [
    {
      title: '前端开发工程师',
      local: '',
      duty: '1、主要负责公司平台和产品网页的研发。<br/>2、利用HTML5相关技术开发移动平台的Web前端页面。<br/>3、持续的优化前端体验和页面响应速度，并保证兼容性和执行效率。',
      demand: '1、全日制本科以上学历，计算机等相关专业。<br/>2、具有三年以上的Web应用开发经验，熟悉HTML、JavaScript、CSS、XML、vue等web开发领域及相关技术。<br/>3、具有微信H5开发或者小程序开发者优先，有相关作品的优先。<br/>4、有较强的责任感，学习能力强，有创造性思维能力和表达能力，充满创业激情。'
    }, {
      title: 'Java研发工程师',
      local: '',
      duty: '1、主要负责公司平台和产品网页的研发。<br/>2、持续输出平台、工具提升研发效能及协同效率。<br/>3、持续驱动协作流程数字化、标准化、智能化。',
      demand: '1、全日制本科以上学历，计算机等相关专业。<br/>2、熟悉Java、Spring、Springboot、理解IO、多线程、集合等基础框架。<br/>3、熟悉常用中间件技术，如消息队列、数据存储、缓存机制、负载均衡等。<br/>4、具备优秀的沟通能力，能够主导推进项目进度情。<br/>5、热爱技术，主动好学，有强烈的责任感、内驱力和团队协作能力 ，具备抗压力。'
    },{
      title: 'Go研发工程师',
      local: '',
      duty: '1、主要负责公司平台和产品网页的研发。<br/>2、持续输出平台、工具提升研发效能及协同效率。<br/>3、持续驱动协作流程数字化、标准化、智能化。',
      demand: '1、全日制本科以上学历，计算机等相关专业。<br/>2、深刻理解计算机原理，有良好的数据结构和算法基础。<br/>3、熟悉常用中间件技术，如消息队列、数据存储、缓存机制、负载均衡等。<br/>4、具备优秀的沟通能力，能够主导推进项目进度情。<br/>5、热爱技术，主动好学，有强烈的责任感、内驱力和团队协作能力 ，具备抗压力。'
    }
  ]
}, {
  title: '市场运营',
  active: '前端开发工程师',
  position: [
    {
      title: '前端开发工程师',
      local: '',
      duty: '1、主要负责公司平台和产品网页的研发。<br/>2、利用HTML5相关技术开发移动平台的Web前端页面。<br/>3、持续的优化前端体验和页面响应速度，并保证兼容性和执行效率。',
      demand: '1、全日制本科以上学历，计算机等相关专业。<br/>2、具有三年以上的Web应用开发经验，熟悉HTML、JavaScript、CSS、XML、vue等web开发领域及相关技术。<br/>3、具有微信H5开发或者小程序开发者优先，有相关作品的优先。<br/>4、有较强的责任感，学习能力强，有创造性思维能力和表达能力，充满创业激情。'
    }
  ]
}, {
  title: '设计',
  active: '前端开发工程师',
  position: [
    {
      title: '前端开发工程师',
      local: '',
      duty: '1、主要负责公司平台和产品网页的研发。<br/>2、利用HTML5相关技术开发移动平台的Web前端页面。<br/>3、持续的优化前端体验和页面响应速度，并保证兼容性和执行效率。',
      demand: '1、全日制本科以上学历，计算机等相关专业。<br/>2、具有三年以上的Web应用开发经验，熟悉HTML、JavaScript、CSS、XML、vue等web开发领域及相关技术。<br/>3、具有微信H5开发或者小程序开发者优先，有相关作品的优先。<br/>4、有较强的责任感，学习能力强，有创造性思维能力和表达能力，充满创业激情。'
    }
  ]
}, {
  title: '销售',
  active: '前端开发工程师',
  position: [
    {
      title: '前端开发工程师',
      local: '',
      duty: '1、主要负责公司平台和产品网页的研发。<br/>2、利用HTML5相关技术开发移动平台的Web前端页面。<br/>3、持续的优化前端体验和页面响应速度，并保证兼容性和执行效率。',
      demand: '1、全日制本科以上学历，计算机等相关专业。<br/>2、具有三年以上的Web应用开发经验，熟悉HTML、JavaScript、CSS、XML、vue等web开发领域及相关技术。<br/>3、具有微信H5开发或者小程序开发者优先，有相关作品的优先。<br/>4、有较强的责任感，学习能力强，有创造性思维能力和表达能力，充满创业激情。'
    }
  ]
}, {
  title: '客服',
  active: '前端开发工程师',
  position: [
    {
      title: '前端开发工程师',
      local: '',
      duty: '1、主要负责公司平台和产品网页的研发。<br/>2、利用HTML5相关技术开发移动平台的Web前端页面。<br/>3、持续的优化前端体验和页面响应速度，并保证兼容性和执行效率。',
      demand: '1、全日制本科以上学历，计算机等相关专业。<br/>2、具有三年以上的Web应用开发经验，熟悉HTML、JavaScript、CSS、XML、vue等web开发领域及相关技术。<br/>3、具有微信H5开发或者小程序开发者优先，有相关作品的优先。<br/>4、有较强的责任感，学习能力强，有创造性思维能力和表达能力，充满创业激情。'
    }
  ]
}, {
  title: '实习生',
  active: '前端开发工程师',
  position: [
    {
      title: '前端开发工程师',
      local: '',
      duty: '1、主要负责公司平台和产品网页的研发。<br/>2、利用HTML5相关技术开发移动平台的Web前端页面。<br/>3、持续的优化前端体验和页面响应速度，并保证兼容性和执行效率。',
      demand: '1、全日制本科以上学历，计算机等相关专业。<br/>2、具有三年以上的Web应用开发经验，熟悉HTML、JavaScript、CSS、XML、vue等web开发领域及相关技术。<br/>3、具有微信H5开发或者小程序开发者优先，有相关作品的优先。<br/>4、有较强的责任感，学习能力强，有创造性思维能力和表达能力，充满创业激情。'
    }
  ]
}];
export default {
  data() {
    return {
      tabArr,
      joinActive: '产品'
    };
  },
  components: {
    'v-free': Free
  }
};
</script>

<style lang="scss">
.join-modular {
  .join-banner {
    height: 360px;
    padding-top: 160px;
    background: url('~@/assets/images/join1.png') center no-repeat;
    background-size: cover;
  }
  .join-banner .join-title {
    margin-bottom: 0;
    font-size: 64px;
    font-weight: 600;
  }
  .aboutUsContent {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: #fff;
  }
  .join-job {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .join-job .join-name {
    cursor: pointer;
    display: inline-block;
    width: 114px;
    line-height: 36px;
    border: 1px solid #666;
    text-align: center;
    height: 36px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 36px;
    margin: 0 15px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    -moz-transition: all 0.3s;
    .el-radio-button__inner {
      padding: 0;
      background-color: transparent;
      border: 0;
      box-shadow: none;
    }
  }
  .join-job .join-name.is-active {
    background: #1472ff;
    color: #fff;
    border-color: #1472ff;
  }
  .join-job .join-name.is-active:hover {
    color: #fff;
  }
  .join-job .join-name:hover {
    color: #1472ff;
    border: 1px solid #1472ff;
  }
  .jobItem {
    width: 100%;
    color: #666;
    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05),
      0 6px 12px 0 rgba(0, 0, 0, 0.04);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05),
      0 6px 12px 0 rgba(0, 0, 0, 0.04);
    margin-bottom: 20px;
    padding: 0 20px;
    border: none;
    .el-collapse-item__header {
      height: auto;
      border: none;
    }
  }
  .jobItem .iconDiv {
    display: inline-block;
    top: -2px;
    color: #b2b2b2;
  }
  .jobItem .jobItemTitle {
    line-height: 30px;
    height: 70px;
    padding: 20px 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    vertical-align: center;
    cursor: pointer;
  }
  .jobItem .jobItemTitle .jobTitle {
    font-size: 16px;
    display: inline-block;
    width: 340px;
    color: #333;
  }
  .jobItem .jobItemTitle .jobAddress {
    font-size: 20px;
    color: #333;
    line-height: 30px;
    position: relative;
    top: -2px;
  }
  .jobItem .jobItemTitle .active {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  .jobItem .jobContent {
    padding-bottom: 18px;
    border-top: 1px solid #eee;
  }
  .jobItem .jobContent.active {
    display: block;
  }
  .jobItem .jobContent h3 {
    font-size: 16px;
    color: #333;
    font-weight: 400;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .jobItem .jobContent p {
    font-size: 16px;
    line-height: 30px;
    margin: 0;
    color: #888;
  }
  .jobItem .jobContent a {
    color: #888;
    font-size: 16px;
    margin-top: 30px;
    display: block;
  }
  .jobItem .jobContent .apply-for {
    width: 180px;
    height: 52px;
    background: #1472ff;
    font-size: 16px;
    color: #fff;
    line-height: 52px;
    text-align: center;
    border: none;
    cursor: pointer;
    margin-top: 25px;
    margin-bottom: 10px;
  }
  .swiper-team {
    overflow: hidden;
  }
  .swiper-team .swiper-slide .name {
    position: absolute;
    width: 100%;
    text-align: center;
    font-size: 24px;
    color: #fff;
    bottom: 40px;
  }
  .welfare-concern {
    background: #f6f9ff;
  }
  .welfare-concern .welfare-list {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .welfare-concern .welfare-list .welfare-item {
    width: 352px;
    color: #333;
  }
  .welfare-concern .welfare-list .welfare-item .welfare-title {
    font-size: 18px;
    margin-bottom: 12px;
    text-align: center;
  }
  .welfare-concern .welfare-list .welfare-item .welfare-desc {
    padding: 0 10px;
    font-size: 16px;
    height: 80px;
  }
}
.app .join-modular {
  padding-top: 1.04rem;
  .join-banner {
    height: 2.4rem;
    padding: 0;
    color: #333;
    font-size: 0.4rem;
    background: url('~@/assets/images/join1_app.png') no-repeat;
    background-size: contain;
    .join-title {
      line-height: 2.4rem;
      color: #333;
      font-size: 0.4rem;
      font-weight: normal;
    }
  }
  .aboutUsContent {
    width: 100%;
    padding-top: 1rem;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    background: #fff;
    margin-bottom: 1.1rem;
    .lz-title1 {
      margin-bottom: 0.8rem;
    }
  }
  .join-job {
    flex-wrap: wrap;
    margin-bottom: 1rem;
    .join-name {
      width: 1.76rem;
      line-height: 0.51rem;
      height: 0.51rem;
      border-radius: 0.26rem;
      margin: 0.13rem 0.2rem;
    }
  }
  .jobItem {
    margin: 0 0.16rem 0.2rem;
    padding: 0 0.44rem;
    width: auto;
    .jobItemTitle {
      line-height: 0.45rem;
      height: 1.05rem;
      padding: 0.3rem 0;
      .jobTitle {
        font-size: 0.32rem;
        width: 5rem;
      }
      .jobAddress {
        font-size: 0.28rem;
        color: #888;
      }
    }
    .jobContent {
      h3 {
        font-size: 0.28rem;
        margin-top: 0.4rem;
        margin-bottom: 0.2rem;
      }
      p {
        font-size: 0.28rem;
        line-height: 0.6rem;
        margin: 0;
      }
      a {
        font-size: 0.32rem;
        margin-top: 0.6rem;
      }
      .apply-for {
        width: 2.75rem;
        height: 0.79rem;
        font-size: 0.32rem;
        line-height: 0.79rem;
        margin: 0.68rem auto 0;
        border-radius: 0.5rem;
      }
    }
  }
  .welfare-concern {
    background: #ffffff;
    padding: 1.2rem 0;
    .lz-title1 {
      margin-bottom: 0.7rem;
    }
    .welfare-list {
      padding: 0 0.3rem;
      .welfare-item {
        width: 3.4rem;
        margin: 0 0 0.48rem;
        img {
          display: block;
          width: 100%;
        }
        .welfare-title {
          font-size: 0.32rem;
          margin-top: 0.3rem;
          margin-bottom: 0.16rem;
        }
        .welfare-desc {
          height: auto;
          color: #707070;
          font-size: 0.2rem;
        }
      }
    }
  }
}
</style>
